<p-toast position="top-center"></p-toast>

<div class="layout-main grid justify-content-center">
  <div
    class="layout-main-content col-12 md:col-8 lg:col-5 flex justify-content-center"
  >
    <div
      class="layout-main-content-panel flex justify-content-center flex-column"
    >
      <img
        class="layout-main-content-panel-logo"
        src="assets/logo/logo-complete.png"
      />
      <h1 class="layout-main-content-panel-title">Inicia sesion</h1>
      <p class="layout-main-content-panel-subtitle">
        Bienvenido, utilice el formulario para iniciar sesión en su panel
        administrativo
      </p>
      <div class="layout-main-content-panel-form">
        <form [formGroup]="form" (ngSubmit)="login()">
          <div class="field">
            <label for="username1">Email</label>
            <input
              class="w-full"
              id="username1"
              type="email"
              formControlName="email"
              aria-describedby="username-help"
              pInputText
            />
          </div>
          <div class="field">
            <label for="float-input-password">Contraseña</label>
            <input
              class="w-full"
              id="float-input-password"
              formControlName="password"
              aria-describedby="password-help"
              type="password"
              pInputText
            />
          </div>
          <br />
          <div class="field">
            <p-button
              styleClass="p-button-custom w-full"
              type="sumbit"
              [icon]="loading ? 'pi pi-spin pi-spinner' : ''"
              [disabled]="!form.valid || loading"
              [label]="loading ? 'Iniciando sesion...' : 'Inicio de sesion'"
            >
            </p-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
